var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form" }, [
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "ovsesCustOcntryName",
          attrs: {
            id: "ovsesCustOcntryName",
            value: _vm.data.ovsesCustOcntryName,
            "label-i18n": "MPRS-01-01-03-06",
            disabled: ""
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "form-row" },
      [
        _c("input-text", {
          ref: "owhusTelno",
          attrs: {
            id: "owhusTelno",
            type: "tel",
            value: _vm.data.owhusTelno,
            "label-i18n": "MPRS-01-01-03-07",
            placeholder: "MPRS-01-01-03-07",
            maxlength: 16,
            "err-msg-param": { filed: _vm.$t("MPRS-01-01-03-07"), max: 16 },
            numeric: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "owhusTelno", $event)
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.siteCode != _vm.$config.SITECODE_OGIND &&
              _vm.siteCode != _vm.$config.SITECODE_OGHCM &&
              _vm.siteCode != _vm.$config.SITECODE_OGCBD,
            expression:
              "siteCode != $config.SITECODE_OGIND && siteCode != $config.SITECODE_OGHCM && siteCode != $config.SITECODE_OGCBD"
          }
        ],
        staticClass: "form-row"
      },
      [
        _c("input-text", {
          ref: "cphnNo",
          attrs: {
            id: "cphnNo",
            type: "tel",
            value: _vm.data.cphnNo,
            "label-i18n": "MPRS-01-01-03-08",
            placeholder: "MPRS-01-01-03-08",
            maxlength: 16,
            "err-msg-param": { filed: _vm.$t("MPRS-01-01-03-08"), max: 16 },
            required:
              _vm.$config.SITECODE_OGAUC + "|" + _vm.$config.SITECODE_OGMMR,
            numeric: ""
          },
          on: {
            "update:value": function($event) {
              return _vm.$set(_vm.data, "cphnNo", $event)
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.siteCode != _vm.$config.SITECODE_OGHCM &&
              _vm.siteCode != _vm.$config.SITECODE_OGCBD,
            expression:
              "siteCode != $config.SITECODE_OGHCM && siteCode != $config.SITECODE_OGCBD"
          }
        ],
        staticClass: "form-row"
      },
      [
        _c(
          "div",
          { staticClass: "item-tit" },
          [
            _vm._v(
              " " + _vm._s(/*이메일 주소*/ _vm.$t("MPRS-01-01-03-09")) + " "
            ),
            _c("required")
          ],
          1
        ),
        _c("div", { staticClass: "item-desc" }, [
          _c("div", { staticClass: "form-text-field" }, [
            _c(
              "div",
              { staticClass: "input-text-field group-email" },
              [
                _c("input-text", {
                  ref: "emailId",
                  attrs: {
                    id: "emailId",
                    value: _vm.data.emailId,
                    placeholder: "MCOP-01-01-03-12",
                    maxlength: 30,
                    "err-msg-param": {
                      filed: _vm.$t("MCOP-01-01-03-12"),
                      max: 30
                    },
                    required:
                      _vm.$config.SITECODE_OGAUC +
                      "|" +
                      _vm.$config.SITECODE_OGMMR +
                      "|" +
                      _vm.$config.SITECODE_OGIND,
                    toLowerCase: ""
                  },
                  on: {
                    "update:value": function($event) {
                      return _vm.$set(_vm.data, "emailId", $event)
                    }
                  }
                }),
                _c("span", { staticClass: "email-at" }, [_vm._v("@")]),
                _c("input-text", {
                  ref: "emailAddress",
                  attrs: {
                    id: "emailAddress",
                    value: _vm.data.emailAddress,
                    maxlength: 30,
                    "err-msg-param": {
                      filed: _vm.$t("MCOP-01-01-03-12"),
                      max: 30
                    },
                    required:
                      _vm.$config.SITECODE_OGAUC +
                      "|" +
                      _vm.$config.SITECODE_OGMMR +
                      "|" +
                      _vm.$config.SITECODE_OGIND,
                    toLowerCase: ""
                  },
                  on: {
                    "update:value": function($event) {
                      return _vm.$set(_vm.data, "emailAddress", $event)
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.siteCode != _vm.$config.SITECODE_OGIND,
            expression: "siteCode != $config.SITECODE_OGIND"
          }
        ],
        staticClass: "form-row"
      },
      [
        _c("div", { staticClass: "item-tit" }, [
          _vm._v(_vm._s(/*우편물 수신*/ _vm.$t("MPRS-01-01-06-06")))
        ]),
        _c(
          "div",
          { staticClass: "item-desc" },
          [
            _c("radio-box", {
              ref: "postSendAreaDstcd",
              attrs: {
                id: "postSendAreaDstcd",
                "data-list": _vm.codeInfo.postSendAreaDstcd.code,
                value: _vm.data.postSendAreaDstcd
              },
              on: {
                "update:value": function($event) {
                  return _vm.$set(_vm.data, "postSendAreaDstcd", $event)
                }
              }
            })
          ],
          1
        )
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.siteCode === _vm.$config.SITECODE_OGAUC,
            expression: "siteCode === $config.SITECODE_OGAUC"
          }
        ],
        staticClass: "form-row"
      },
      [
        _c("radio-box", {
          ref: "postSendYn",
          attrs: {
            id: "postSendYn",
            "data-list": _vm.codeInfo.postSendYn.code,
            value: _vm.postSendYn,
            "title-i18n": _vm.codeInfo.postSendYn.name,
            required: "" + _vm.$config.SITECODE_OGAUC
          },
          on: {
            "update:value": function($event) {
              _vm.postSendYn = $event
            }
          }
        }),
        _c("div", { staticClass: "info info-etc" }, [
          _vm._v(
            "※ " +
              _vm._s(
                /*조회 > 거래내역조회 > Statement조회에서 조회 후 인쇄할 수 있습니다.*/ _vm.$t(
                  "MPRS-01-01-06-12"
                )
              )
          )
        ])
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.siteCode === _vm.$config.SITECODE_OGAUC &&
              _vm.data.postSendYn == "1",
            expression:
              "siteCode === $config.SITECODE_OGAUC && data.postSendYn=='1'"
          }
        ],
        staticClass: "form-row"
      },
      [
        _c(
          "div",
          { staticClass: "item-tit" },
          [
            _vm._v(
              " " +
                _vm._s(
                  /*Statement 우편수신서비스 신청*/ _vm.$t("MPRS-01-01-06-15")
                ) +
                " "
            ),
            _c("required")
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "item-desc" },
          [
            _c(
              "vuelidate-form",
              { attrs: { validator: _vm.$v.data.isPostSendYnAgree } },
              [
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.isPostSendYnAgree,
                        expression: "data.isPostSendYnAgree"
                      }
                    ],
                    ref: "isPostSendYnAgree",
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "isPostSendYnAgree" },
                    domProps: {
                      checked: Array.isArray(_vm.data.isPostSendYnAgree)
                        ? _vm._i(_vm.data.isPostSendYnAgree, null) > -1
                        : _vm.data.isPostSendYnAgree
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.data.isPostSendYnAgree,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.data,
                                "isPostSendYnAgree",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.data,
                                "isPostSendYnAgree",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.data, "isPostSendYnAgree", $$c)
                        }
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "isPostSendYnAgree" }
                    },
                    [
                      _vm._v(
                        _vm._s(/*우편수신 동의*/ _vm.$t("MPRS-01-01-06-16"))
                      )
                    ]
                  )
                ])
              ]
            ),
            _c("div", { staticClass: "info info-etc-col" }, [
              _c("p", [
                _vm._v(
                  "※ " +
                    _vm._s(
                      /*다음달부터 요청하신 수신지로 Statement를 받아 보시게 됩니다.*/ _vm.$t(
                        "MPRS-01-01-06-17"
                      )
                    )
                )
              ]),
              _c("p", [
                _vm._v(
                  "※ " +
                    _vm._s(
                      /*우편물 수신지의 주소가 맞는지 확인해주시고, 주소가 올바르지 않을 경우 영업점 변경 요청 후 해당 서비스를 신청하시기 바랍니다.*/ _vm.$t(
                        "MPRS-01-01-06-18"
                      )
                    )
                )
              ]),
              _c("p", [
                _vm._v(
                  "※ " +
                    _vm._s(
                      /*우편으로 수신을 요청한 경우에 고객주소가 외국이거나 주소가 불분명한 경우는 발송이 되지 않을 수도 있습니다.*/ _vm.$t(
                        "MPRS-01-01-06-19"
                      )
                    )
                )
              ])
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }